import React, { useEffect, useState } from 'react';
import { useStringsContext } from '../../../../../contexts/strings';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Story } from '../../types';
import VideoPlayer from '../video-player';
import { SxStyle } from '../../../../../types';
import moment from 'moment';
import Button from '@mui/material/Button';
import { useFotbollPlayVideo } from '../../hooks/video';
import Loading from '../../../../loading';
import PreviewBox from '../../../../common/preview-box';

const videoJsOptions = {
  autoplay: true,
  controls: true,
  responsive: false,
  fluid: true,
  height: '480px',
  aspectRatio: '9:16',
};

const styles: SxStyle = {
  info: {
    position: 'absolute',
    bottom: '65px',
    left: 30,
  },
  button: {
    marginTop: '2px',
    border: '1px solid #515151',
  },
};

interface Props {
  selectedStory: Story;
  selectedLeague: string;
}

const StoryPreviewCard = ({ selectedStory, selectedLeague }: Props) => {
  const { strings } = useStringsContext();
  const { fetchVideoData } = useFotbollPlayVideo();
  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  useEffect(() => {
    async function fetchVideo() {
      try {
        const videoId = selectedStory?.videoUrl.split('/').pop();
        if (!videoId) {
          throw new Error('Video ID not found!');
        }

        const videoData = await fetchVideoData(videoId, selectedLeague);
        const videoUrl = videoData?.video_url;
        if (!videoUrl) {
          throw new Error('Video url not found!');
        }

        setVideoUrl(videoUrl);
      } catch (error) {
        console.error(error);
      }
    }
    fetchVideo();
  }, [fetchVideoData, selectedLeague, selectedStory?.videoUrl]);

  return (
    <Stack spacing={4} alignItems="center">
      <Typography variant="body1">{strings.stories.previewTitle}</Typography>
      {selectedStory && (
        <PreviewBox>
          {videoUrl ? (
            <>
              <VideoPlayer
                options={{
                  ...videoJsOptions,
                  sources: [
                    {
                      src: videoUrl,
                      type: 'application/x-mpegURL',
                    },
                  ],
                }}
              />
              <Box sx={styles.info}>
                <Typography variant="body1-bold" color="contrast.main">
                  {selectedStory.caption}
                </Typography>
                <Typography variant="body2" fontSize={10} color="contrast.main">
                  {strings.stories.previewPublishedText.replace(
                    '$time',
                    moment(selectedStory.startTime).format('ll')
                  )}
                </Typography>
                {selectedStory.buttonUrl && selectedStory.buttonUrl && (
                  <Button variant="contained" sx={styles.button}>
                    {selectedStory.buttonText}
                  </Button>
                )}
              </Box>
            </>
          ) : (
            <Loading />
          )}
        </PreviewBox>
      )}
    </Stack>
  );
};

export default StoryPreviewCard;
